import WorkspaceAPI from '../WorkspaceAPI';
import useMyWorkspace from './useMyWorkspace';

function useCurrentWorkspace(marketId?: string) {
  const myWorkspaceResult = useMyWorkspace();
  const marketWorkspaceResult =
    WorkspaceAPI.endpoints.getWorkspaceById.useQuery(marketId ?? '', {
      skip: !marketId,
    });

  if (marketId && marketWorkspaceResult.data) {
    return marketWorkspaceResult;
  }

  return myWorkspaceResult;
}

export default useCurrentWorkspace;
